<template>
    <div>
        <div class="pc">
            <toptab :topback="true"></toptab>
            <div class="digital">
                <div class="createbutton">
                    <p @click="createvideo()">立即生成</p>
                    <p @click="jumppage()">创作历史</p>
                </div>
                <div class="microvideoboxleft">
                    <asidebar></asidebar>
                </div>
                <div class="microvideoboxright">
                    <el-scrollbar>
                        <div class="digitalbox">
                            <div>
                                <div class="titlebox">
                                    <div>
                                        <p>01.</p>
                                        <p>
                                            <span>选择一张图片</span>
                                            <span>请使用五官清晰的单人正脸图片</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="upload">
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        action=""
                                        accept="image/jpg,image/jpeg,image/png"
                                        :http-request="UploadImage"
                                        :show-file-list="false">
                                        <div class="uploadbutton">
                                            <el-button type="primary"><i class="el-icon-upload2"></i>上传图片</el-button>
                                            <p>或拖拽图片到此处</p>
                                        </div>
                                    </el-upload>
                                    <p class="tip"><i class="el-icon-warning-outline"></i>{{website.web_title}}不会保存你的图片，制作完成即自动删除</p>
                                </div>
                                <div class="role">
                                    <!-- <p class="roletitle">
                                        <i class="el-icon-s-opportunity"></i>
                                        <span>没有照片？用这些图片试试吧</span>
                                    </p> -->
                                    <ul class="lists" v-if="list.length>0" >
                                         <el-image :preview-src-list="list" style="width: 100px;height: 100px;" v-for="(item,index) in list" fit="fill" :src="item" />
                                    </ul>
                                    <el-dialog
                                        :visible.sync="dialogVisible"
                                        :destroy-on-close="true"
                                        width="30%">
                                        <video v-if="dialogVisible" :src="list[listindex]" style="width: 100%;height:300px" controls autoplay></video>
                                    </el-dialog>
                                    <!-- <div class="selectbox">
                                        <ul>
                                            <li>作品去水印</li>
                                            <li>
                                                <el-switch
                                                v-model="watermark">
                                                </el-switch>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                卡通适配
                                                <el-tooltip class="item" effect="dark" content="如果选择照片是卡通人物，建议勾选" placement="top">
                                                    <i class="el-icon-question"></i>
                                                </el-tooltip>
                                            </li>
                                            <li>
                                                <el-switch
                                                v-model="cartoon">
                                                </el-switch>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                说话姿态
                                            </li>
                                            <li>
                                                <el-select v-model="attitude" placeholder="请选择">
                                                    <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </li>
                                        </ul>
                                    </div> -->
                                </div>
                            </div>
                            <div>
                                <div class="titlebox">
                                    <div>
                                        <p>02.</p>
                                        <p>
                                            <span>输入让视频说话的内容</span>
                                            <span>您可以选择输入文字或上传语音音频</span>
                                        </p>
                                    </div>
                                    <!-- <div>
                                        <i class="el-icon-s-opportunity"></i>
                                        <span>没有灵感？插入范文</span>
                                    </div> -->
                                </div>
                                <div class="tab">
                                    <ul>
                                        <li :class="tabindex?'on':''" @click="tabindex=true">输入文字</li>
                                        <li :class="!tabindex?'on':''" @click="tabindex=false">上传语音</li>
                                    </ul>
                                </div>
                                <div v-show="tabindex" class="tabbox1">
                                    <el-input
                                        type="textarea"
                                        placeholder="想要照片说些什么内容？请写在这里吧"
                                        resize="none"
                                        v-model="voiceForm.content"
                                        style="height: 167px;">
                                    </el-input>
                                    <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" >
                                        <el-menu-item index="1">阿里云角色</el-menu-item>
                                        <el-menu-item index="2">微软角色</el-menu-item>
                                        <el-menu-item index="3">科大讯飞</el-menu-item>
                                        <el-menu-item index="4">火山引擎角色</el-menu-item>
                                    </el-menu> -->
                                    <div v-show="activeIndex==1" class="ali">
                                        <ul class="type">
                                            <li v-for="(item,index) in alitype" :key="index" :class="alitypeindex==item.id?'on':''" @click="changeRole(item.id)">{{item.title}}</li>
                                        </ul>
                                        <el-scrollbar>
                                            <ul class="usebox" v-if="alitypeindex != 10000">
                                                <li  v-for="(item,index) in ali" :key="index" :class="voiceForm.model_id==item.id?'on':''" @click="voiceForm.model_id=item.id">
                                                    <div><img :src="item.image" alt=""></div>
                                                    <div>{{item.role_name}}</div>
                                                    <div>{{item.description}}</div>
                                                </li>
                                            </ul>
											<ul class="usebox1" v-if="alitypeindex == 10000">
											    <li   v-for="(item,index) in ali" :key="index" :class="voiceForm.model_id==item.id?'on':''" @click="voiceForm.model_id=item.id">
											        <div>{{item.title}}</div>
											    </li>
												<li v-if="ali.length == 0"  class="on" @click="jumpClone()">
												    <div>定制声音克隆</div>
												</li>
											</ul>
                                        </el-scrollbar>
                                        <div class="slider">
                                            <p>音量</p>
											<el-button size="mini" icon="el-icon-minus" @click="decreaseVolume(-1)"></el-button>
                                            <el-slider v-model="voiceForm.volume" :min='0' :max='100'></el-slider>
                                            <p>{{voiceForm.volume}}</p>
											<el-button size="mini" icon="el-icon-plus" @click="decreaseVolume(1)"></el-button>
                                        </div>
                                        <div class="slider">
                                            <p>语速</p>
											<el-button size="mini" icon="el-icon-minus" @click="decreaseSpeed(-10)"></el-button>
                                            <el-slider v-model="voiceForm.speed" :min='-500' :max='500'></el-slider>
                                            <p>{{voiceForm.speed}}</p>
											<el-button size="mini" icon="el-icon-plus" @click="decreaseSpeed(10)"></el-button>
                                        </div>
                                        <div class="slider">
                                            <p>语调</p>
											<el-button size="mini" icon="el-icon-minus" @click="decreaseIntonation(-10)"></el-button>
                                            <el-slider v-model="voiceForm.intonation" :min='-500' :max='500'></el-slider>
                                            <p>{{voiceForm.intonation}}</p>
											<el-button size="mini" icon="el-icon-plus" @click="decreaseIntonation(10)"></el-button>
                                        </div>
                                        <p @click="createflie()" class="button">生成语音</p>
                                    </div>
                                </div>
                                <div v-show="!tabindex" class="tabbox2">
                                    <el-upload
                                        class="upload-demo"
                                        :limit="1"
                                        drag
                                        action=""
                                        accept="audio/mpeg,audio/wav,audio/x-wav"
                                        :http-request="uploadVoice"
                                        :show-file-list="true"
                                        :file-list="videoList">
                                        <div class="uploadbutton">
                                            <el-button type="primary"><i class="el-icon-upload2"></i>上传音频</el-button>
                                            <p>或拖拽音频到此区域</p>
                                        </div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <div class="mobile">
            <facem></facem>
        </div>
        <videoplay v-if="videoplaystatus" @colsevideo="colsevideo" :videoid="videoid"></videoplay>
        <voiceplay v-if="voiceplaystatus" @colsevideo="colsevideo" :audioUrl="videoForm.voice_url"></voiceplay>
		<membertc v-if="dialogRechargeVisible" @closemember="closemember"></membertc>
    </div>
</template>

<script>
import videoplay from '@/components/videoplay'
import voiceplay from "@/components/voiceplay";
import toptab from "@/components/toptab"
import asidebar from "@/components/asidebar"
import facem from "@/components/facem"
import membertc from '@/components/membertc'
import {uploadUploadVideo,uploadUploadImage,voiceGetModelList,voiceGenerate,uploadUploadVoice,videoCreate,videoDetail} from "@/api/video"
export default {
    components: {
        toptab,
        asidebar,
        facem,
        videoplay,
        membertc,
        voiceplay
    },
    data(){
        return{
            dialogVisible:false,
            dialogRechargeVisible:false,
            videoList:[],
            voiceplaystatus:false,
            videoplaystatus: false,
            activeIndex:'1',
            textarea:"",
            tabindex:true,
            watermark:false,
            cartoon:false,
            attitude:0,
			website: this.$store.website,
            options:[
                {
                    value:0,
                    label:"无动作（仅嘴巴说话）"
                },
                {
                    value:1,
                    label:"仅眨眼，面部不转动"
                },
                {
                    value:2,
                    label:"眨眼 + 面部自然转动"
                },
                {
                    value:3,
                    label:"眨眼 + 面部中幅度转动"
                },
                {
                    value:4,
                    label:"眨眼 + 面部大幅转动"
                },
            ],
            listindex:0,
            list:[
   
            ],
            alitypeindex:10000,
            alitype:[],
            ali:[],
            voiceForm:{
                content:"",
                volume:50,
                speed:0,
                intonation:0,
                model_id:"",
                creation_id:2//数字人
            },
            videoForm:{
                content:"",
                tid:"",
                video_url:"",
                voice_url:"",
				model_id:0,
                creation_id:2
            },
            videoid:1,
            template_id:0,
        }
    },
    mounted(){
		if (this.$route.query.tid != undefined && this.$route.query.tid != "" && this.$route.query.id != "0") {
			this.template_id = this.$route.query.tid
			this.getVideoTemplate();
		}
		console.log(this.template_id)
        this.voiceGetModelList()
    },
    methods:{
		decreaseVolume(v) {
			if(this.voiceForm.volume >= 100 || this.voiceForm.volume <=0) {
				return;
			} 
			this.voiceForm.volume = this.voiceForm.volume + v;
		},
		decreaseSpeed(v) {
			if(this.voiceForm.speed >= 500 || this.voiceForm.speed <= -500) {
				return;
			} 
			this.voiceForm.speed = this.voiceForm.speed + v;
		},
		decreaseIntonation(v) {
			if(this.voiceForm.intonation >= 500 || this.voiceForm.intonation <= -500) {
				return;
			} 
			this.voiceForm.intonation = this.voiceForm.intonation + v;
		},
		getVideoTemplate() {
			videoDetail({ id: this.template_id }).then((res) => {
			  this.list.push(res.data.template.video_url);
			});
		},
        jumppage(){
            this.$router.push({ path: '/history/2'});
        },
		jumpClone(){
            this.$router.push({ path: '/clone'});
        },
        createflie(){
            // this.videoplaystatus=true
            // if(this.tabindex){
                if(this.voiceForm.content==""){
                    this.$message.error('文本不能为空');
                    return false
                }
                const loading1 = this.$loading({
                    lock: true,
                    text: '语音生成中....',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                voiceGenerate(this.voiceForm).then(res=>{
                    loading1.close()
					if(res.code == 1) {
						this.$message.error(res.message)
					}else {
						this.videoForm.voice_url = res.data.url
						this.voiceplaystatus = true
					}
                    // this.createvideo()
                })
            // }else{
            //     this.createvideo()
            // }
        },
		closemember() {
			this.dialogRechargeVisible = false;
		},
        createvideo(){
			
            if(!this.tabindex){
                this.videoForm.voice_url = this.videoList;
            } 
            if(this.videoForm.voice_url==""){
                this.$message.error("语音文件不能为空");
                return false;
            } 
			// if(this.voiceForm.content == "") {
			// 	this.$message.error("请输入文字内容");
			// 	return false;
			// }
            this.videoForm.content = this.voiceForm.content;
            this.videoForm.video_url = this.list[this.listindex];
            if(this.videoForm.video_url==""){
                this.$message.error("视频文件不能为空");
                return false;
            } 
			this.videoForm.tid = this.template_id;
            videoCreate(this.videoForm).then((res) => {
				if(res.code == 1) {
					this.$message.error(res.message)
				}else if(res.code == 106) {
					this.$message.error(res.message)
					this.dialogRechargeVisible = true;
					return false;
				}else {
					// this.videoid = res.data.id;
					// this.videoplaystatus = true;
					this.$router.push({ path: '/history/2'});
				}
               
                // this.$router.push({ path: '/history/2'});
            });
        },
        colsevideo(){
            this.videoplaystatus=false
            this.voiceplaystatus = false
        },
        changeRole(id){
            this.alitypeindex = id
            this.voiceGetModelList()
        },
        voiceGetModelList(){
            voiceGetModelList({cid:this.alitypeindex}).then(res=>{
                this.alitype = res.data.category_list
                this.ali = res.data.model_list
				if(this.ali != null && this.ali.length > 0) {
					this.voiceForm.model_id = this.ali[0].id
				}
				this.alitypeindex = res.data.cid;
            })
        },
        uploadVoice(e){
             const loading2 = this.$loading({
                lock: true, 
                text: '文件上传中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData()
            formData.append('file', e.file)
            uploadUploadVoice(formData).then(res=>{
                loading2.close();
                this.videoList = res.data.fullurl
            })
        },
        UploadImage(e){
            const loading3 = this.$loading({
                lock: true,
                text: '文件上传中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData()
            formData.append('file', e.file)
            uploadUploadImage(formData).then(res=>{
                loading3.close();
				this.list = [];
				this.list.push(res.data.fullurl)
				this.template_id = 0;
            })
        }
    }
}
</script>

<style lang="less">
    .digital{
        display: flex;
        .createbutton{
            position: absolute;
            top: 12px;
            right: 80px;
            display: flex;
            p:nth-child(1){
                background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
                height: 36px;
                padding: 0 20px;
                border: 0;
                border-radius: 6px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-size: 14px;
            }
            p:nth-child(2){
                height: 36px;
                padding: 0 20px;
                border: 0;
                border-radius: 6px;
                background-color:rgb(244, 245, 247);
                color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 20px;
                cursor: pointer;
                font-size: 14px;
            }
        }
        .microvideoboxright{
            background-color: #f4f5f7;
            padding: 30px 20px 0;
            flex: 1 0 10%;
            // width:calc(100vw - 340px);
            >.el-scrollbar{
                height: calc(100vh - 90px);
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }

            .digitalbox{
                display: flex;
                gap: 20px;
                .titlebox{
                    display: flex;
                    justify-content: space-between;
                    div{
                        display: flex;
                        align-items: center;
                        p:nth-child(1){
                            color: #678bfe;
                            font-size: 20px;
                            font-weight: 700;
                            margin-right: 8px;
                        }
                        p:nth-child(2){
                            span{
                                display: block;
                            }
                            span:nth-child(1){
                                font-size: 20px;
                                font-weight: 700;
                                margin-bottom: 4px;
                                margin-bottom: 4px;
                            }
                            span:nth-child(2){
                                color: #999;
                                font-size: 14px;
                            }
                        }
                        i{
                            color: #E6A23C;
                        }
                        span{
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
                > div{
                    padding: 20px;
                    background-color: #fff;
                    border-radius: 12px;
                    position: relative;
                    overflow: hidden;
                }
                > div:nth-child(1){
                    width: 540px;
                    .upload{
                        margin-top: 20px;
                        width: 100%;
                        .el-upload{
                            width: 100%;
                            height: 200px;
                        }
                        .el-upload-dragger{
                            height: 200px;
                            background-color: rgba(45, 138, 245, 0.06);
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .uploadbutton{
                                p{
                                    color: rgb(96, 98, 102);
                                    font-size: 14px;
                                    text-align: center;
                                    margin-top: 12px;
                                }
                            }
                        }
                        .tip{
                            font-size: 12px;
                            color: #999;
                            text-align: center;
                            margin-top: 12px;
                        }
                    }
                    .role{
                        margin-top: 24px;
                        .roletitle{
                            i{
                                color: #E6A23C;
                            }
                            span{
                                color:rgb(51, 51, 51);
                                font-size:12px;
                            }
                        }
                        .lists{
                            display: flex;
                            flex-wrap: wrap;
                            margin-top: 14px;
                            gap: 10px;
                            li{
                                flex: 0 0 23%;
                                position: relative;
                                div{
                                    width: 100%;
                                    height: 100px;
                                    overflow: hidden;
                                    border-radius: 9px;
                                    position: relative;
                                    video{
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        transform: translate(-50%,-50%);
                                        display: block;
                                        width: 100%;
                                        // height: 100%;
                                        cursor: pointer;
                                        position: relative;
                                        z-index: 10;
                                    }
                                }
                            }
                        }

                        .selectbox{
                            margin-top: 24px;
                            padding-top: 24px;
                            border-top: 1px solid rgb(244, 245, 247);
                            ul{
                                display: flex;
                                align-items: center;
                                margin-bottom: 24px;
                                li:nth-child(1){
                                    width: 80px;
                                    margin-right: 10px;
                                    font-size: 14px;
                                    color: #333;
                                    display: flex;
                                    align-items: center;
                                    i{
                                        color: rgb(228, 231, 237);
                                        font-size: 16px;
                                    }
                                }
                            }
                        }
                    }
                }
                > div:nth-child(2){
                    flex: 1 0 10%;
                    .tab{
                        margin-top: 20px;
                        padding: 4px;
                        background-color: #f4f5f7;
                        border-radius: 40px;
                        ul{
                            display: flex;
                            li{
                                flex:0 0 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #666;
                                cursor: pointer;
                                height: 44px;
                                z-index: 1;
                            }
                            .on{
                                color: #333;
                                background-color: #fff;
                                border-radius: 40px;
                            }
                        }
                    }
                    .tabbox1{
                        margin-top: 24px;
                        .button{
                            width: 200px;
                            margin: 40px auto 0;
                            background-image: linear-gradient(
                                106.92deg,
                                rgb(16, 197, 254) 14.83%,
                                rgb(16, 147, 254) 31.52%,
                                rgb(79, 79, 231) 65.11%,
                                rgb(182, 12, 185) 91.29%,
                                rgb(224, 202, 245) 102.83%
                            );
                            height: 42px;
                            padding: 0 20px;
                            border: 0;
                            border-radius: 6px;
                            color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            font-size: 16px;
                        }
                        .el-textarea{
                            background: #f4f5f7;
                            border: 1px solid #f4f5f7;
                            border-radius: 8px;
                            padding: 10px ;
                            .el-textarea__inner{
                                position: relative;
                                --el-fill-color-blank: transparent;
                                height: 100%;
                                background-color: transparent;
                                border: none;
                            }
                        }
                        .type{
                            display: flex;
                            gap: 8px;
                            margin-top: 20px;
                            li{
                                text-align: center;
                                padding: 5px 12px;
                                border: 1px solid #f4f5f7;
                                border-radius: 6px;
                                background: #fff;
                                flex-shrink: 0;
                                cursor: pointer;
                                font-size: 14px;
                            }
                            .on{
                                background: #f4f5f7;
                            }
                        }
                        .el-scrollbar{
                            height: 300px;
                            .el-scrollbar__wrap{
                                overflow-x: hidden;
                            }
                        }
                        .usebox{
                            display: flex;
                            flex-wrap: wrap;
                            gap:12px;
                            margin-top: 24px;
                            li{
                                width: 200px;
                                height: 48px;
                                border: 1px solid #f4f5f7;
                                background-color: #f4f5f7;
                                border-radius: 8px;
                                margin: 5px 0;
                                padding: 0 8px;
                                cursor: pointer;
                                position: relative;
                                display: flex;
                                align-items: center;
                                justify-content: space-betweenc;
                                font-size: 14px;
                                color: #333;
                                img{
                                    width: 28px;
                                    margin: 0 8px;
                                }
                                div:nth-child(3){
                                    flex: 1 0 10%;
                                }
                                div:nth-child(2){
                                    margin-right: 12px;
                                    padding-right: 12px;
                                    position: relative;
                                    border-right: 1px solid #ddd;
                                }
                            }
                            .on{
                                border: 1px solid #2d8af5;
                                background-color: #2d8af5;
                                color: #fff;
                            }
                        }
						.usebox1{
						    display: flex;
						    flex-wrap: wrap;
						    gap:12px;
						    margin-top: 24px;
						    li{
								justify-content: center;
						        width: 200px;
						        height: 48px;
						        border: 1px solid #f4f5f7;
						        background-color: #f4f5f7;
						        border-radius: 8px;
						        margin: 5px 0;
						        padding: 0 8px;
						        cursor: pointer;
						        position: relative;
						        display: flex;
						        align-items: center;
						        justify-content: space-betweenc;
						        font-size: 14px;
						        color: #333;
						        img{
						            width: 28px;
						            margin: 0 8px;
						        }
						        div:nth-child(3){
						            flex: 1 0 10%;
						        }
						        div:nth-child(2){
						            margin-right: 12px;
						            padding-right: 12px;
						            position: relative;
						            border-right: 1px solid #ddd;
						        }
						    }
						    .on{
						        border: 1px solid #2d8af5;
						        background-color: #2d8af5;
						        color: #fff;
						    }
						}
                        .slider{
                            display: flex;
                            align-items: center;
                            width: 350px;
                            font-size: 14px;
                            border: 1px solid #e6e9ed;
                            border-radius: 8px;
                            padding: 16px 20px;
                            gap: 10px;
                            margin-bottom: 10px;
                            .el-slider{
                                flex: 1 0 10%;
                            }
                        }
                    }
                    .tabbox2{
                        margin-top: 20px;
                        width: 100%;
                        .el-upload{
                            width: 100%;
                            height: 200px;
                        }
                        .el-upload-dragger{
                            height: 200px;
                            background-color: rgba(45, 138, 245, 0.06);
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .uploadbutton{
                                p{
                                    color: rgb(96, 98, 102);
                                    font-size: 14px;
                                    text-align: center;
                                    margin-top: 12px;
                                }
                            }
                        }
                        .tip{
                            font-size: 12px;
                            color: #999;
                            text-align: center;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
    }
</style>